// Shared copy + form defaults for the preaction options, used by the creation
// modal (description.create) and the detail viewer (description.view). defaultValue
// is only the form's initial value; the backend owns the real defaults.
export const PREACTION_OPTIONS = {
    default_filter: {
        label: "Default Class Filter",
        checkboxLabel: "Include default class filter",
        description: {
            create: "Also exclude the database's default-filtered classes, on top of the ones you selected.",
            view: "Whether the database's default-filtered classes are also excluded from training.",
        },
    },
    excluded_classes: {
        label: "Custom Excluded Classes",
        description: {
            create: "Choose classes to exclude from training, on top of (or instead of) the default class filter. Leave empty to keep all classes.",
            view: "Classes excluded from training, on top of (or instead of) the default class filter.",
        },
    },
    included_classes: {
        label: "Included Classes",
        description: {
            create: "Train only these classes; their child classes are included automatically, and everything else is excluded. Mutually exclusive with excluded classes.",
            view: "Only these classes (and their child classes) are trained; everything else is excluded.",
        },
    },
    min_samples: {
        label: "Minimum Samples per Class",
        defaultValue: 10,
        description: {
            create: "Set the minimum number of samples a class must have to be included in training.",
            view: "Classes with fewer than this many samples are excluded from training.",
        },
    },
    max_samples: {
        label: "Maximum Samples per Class",
        defaultValue: 3000,
        description: {
            create: "Set the maximum number of samples per class used in one training epoch; larger classes are down-weighted to balance the data.",
            view: "Maximum number of samples per class used in one training epoch; larger classes are down-weighted to balance the data.",
        },
    },
}
